import { Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { styled } from '@mui/system';
import VideoModal from '../../../../components/modais/VideoModal';
import { useState } from 'react';

const Container = styled(Box)({
    border: '1px solid #ccc',
});

const Title = styled(Typography)({
    fontWeight: '500',
});

const SectionContainer = styled(Box)({
    border: '1px solid #ccc',
});
const BrowserControl = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
});

const Terminal = ({
    terminal,
    handleOpenBrowser,
    handleCloseBrowser,
    handleRefreshBrowser,
    handleGetComports,
    handleSetComport,
    handleConnectComport,
    handleCloseComport,
    handleSendDataToComport,
}) => {
    const [number, setNumber] = useState('');
    const [command, setCommand] = useState('');
    const [openVideoModal, setOpenVideoModal] = useState(false);
    const handleClickOpenVideoModal = (n) => {
        setNumber(n);
        setOpenVideoModal(true);
    };
    const handleCloseVideoModal = () => {
        setOpenVideoModal(false);
    };

    const handleComportChange = (number, event) => {
        // console.log(number);
        // console.log(event.target.value);
        handleSetComport(number, event.target.value)
    }

    const getBrowserState = (isOpen) => {
        if (isOpen) {
            return 'Aberto';
        } else {
            return 'Fechado';
        }
    }

    const getComState = (IsConnected) => {
        if (IsConnected) {
            return 'Conectado';
        } else {
            return 'Desconectado';
        }
    }

    return (
        <Container p={2}>
            <Title>Terminal {terminal?.Number}</Title>

            <SectionContainer p={2} mt={2}>
                <Title>Navegador</Title>
                <Box my={2}>
                    <Typography fontSize={'0.9rem'}><strong>Estado: </strong>{getBrowserState(terminal?.Browser?.IsOpen)}</Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid xs={12} md={4} sx={{ justifyContent: 'center' }}>
                        {terminal?.Browser?.IsOpen
                            ?
                            <Button
                                variant="contained"
                                size='small'
                                color='error'
                                fullWidth
                                onClick={() => handleCloseBrowser(terminal?.Number)}
                            >
                                Fechar navegador
                            </Button>
                            :
                            <Button
                                variant="contained"
                                size='small'
                                fullWidth
                                onClick={() => handleOpenBrowser(terminal?.Number)}
                            >
                                Abrir navegador
                            </Button>
                        }

                    </Grid>
                    <Grid xs={12} md={4}>
                        <Button
                            variant="contained"
                            size='small'
                            color='secondary'
                            fullWidth
                            onClick={() => handleClickOpenVideoModal(terminal?.Number)}
                        >
                            Ver navegador
                        </Button>
                    </Grid>
                    <Grid xs={12} md={4}>
                        <Button
                            variant="contained"
                            size='small'
                            color='warning'
                            fullWidth
                            onClick={() => handleRefreshBrowser(terminal?.Number)}
                        >
                            Reiniciar navegador
                        </Button>
                    </Grid>
                </Grid>
            </SectionContainer>

            <SectionContainer p={2} mt={2}>
                <Title>Comunicação - Porta COM</Title>
                <Box my={2}>
                    <Typography fontSize={'0.9rem'}><strong>Estado: </strong>{getComState(terminal?.Comport?.IsConnected)}</Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => handleGetComports(terminal?.Number)}
                            >
                                Buscar portas
                            </Button>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={4} sx={{ justifyContent: 'center' }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-select-comport">Porta COM</InputLabel>
                            <Select
                                labelId="label-select-comport"
                                id="select-comport"
                                value={terminal?.Comport?.PortName}
                                label="Porta COM"
                                onChange={(e) => handleComportChange(terminal?.Number, e)}
                            >
                                <MenuItem value={'-1'}>Selecione uma porta</MenuItem>
                                {terminal?.Comport?.AvailablePorts.map(item =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid xs={12} md={4} sx={{ justifyContent: 'center' }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-select-baudrate">Baudrate</InputLabel>
                            <Select
                                labelId="label-select-baudrate"
                                id="select-baudrate"
                                value={terminal?.Comport?.BaudRate}
                                label="Baudrate"
                            // onChange={handleChange}
                            >
                                <MenuItem value={'300'}>300</MenuItem>
                                <MenuItem value={'9600'}>9600</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            {terminal?.Comport?.IsConnected
                                ?
                                <Button
                                    variant="contained"
                                    color='error'
                                    fullWidth
                                    onClick={() => handleCloseComport(terminal?.Number)}
                                >
                                    Desconectar
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    color='success'
                                    fullWidth
                                    onClick={() => handleConnectComport(terminal?.Number)}
                                >
                                    Conectar
                                </Button>
                            }
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid xs={6} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Button
                                variant="contained"
                                color='warning'
                                fullWidth
                                onClick={() => handleSendDataToComport(terminal?.Number, command)}
                            >
                                Enviar comando
                            </Button>
                        </Box>
                    </Grid>
                    <Grid xs={6} md={4}>
                        <TextField
                            id="outlined-basic"
                            label="Comando"
                            variant="outlined"
                            fullWidth
                            value={command}
                            onChange={(e) => setCommand(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </SectionContainer>

            <VideoModal
                open={openVideoModal}
                handleClose={handleCloseVideoModal}
                number={number}
                handleOpenBrowser={handleOpenBrowser}
                handleCloseBrowser={handleCloseBrowser}
                handleRefreshBrowser={handleRefreshBrowser}
            />
        </Container >
    )
}
export default Terminal;